import React from 'react';

/**
 * 그룹명 셀 컴포넌트
 * 
 * 그룹명과 차수를 표시합니다.
 * 
 * @param {Object} params - DataGrid의 renderCell 파라미터
 * @param {Object} params.row - 행 데이터
 * @param {string} params.row.groupCourse - 그룹명
 * @param {number} params.row.groupCourseCount - 차수
 */
const GroupCourseCell = ({ row }) => {
  const courseCount = row.groupCourseCount;
  const courseName = row.groupCourse || '-';
  
  return courseCount ? `${courseName} (${courseCount}차수)` : courseName;
};

export default GroupCourseCell;
